import React from 'react';

import { flex, maxHeightWithoutNav, flexOne } from '@/styles';
import { Page, Content } from '@/components/primitive';
import PageRoutes from '@/routes';

const Body: React.FC = props => {
  const ref = React.useRef(null);

  return (
    <div ref={ref} id="content" css={[flex, maxHeightWithoutNav, flexOne]} {...props}>
      <Page>
        <Content>
          <PageRoutes />
        </Content>
      </Page>
    </div>
  );
};

export default Body;
